import React from 'react'

const paragraph = Object.assign({fontSize: '16px'}, {textAlign: 'justify'})

class ChangeLog extends React.Component {
  render () {
    return (
      <div className="row">
        <div className="col-md-10 col-md-offset-1">
          <div>
            <h2>Changelog</h2>
            <p style={paragraph}>2017-08-14 - Player values updated.</p> 
            <p style={paragraph}>2017-08-08 - Update for 2017.</p> 
            <p style={paragraph}>2016-09-02 - Player values updated.</p> 
            <p style={paragraph}>2016-08-10 - Player values updated.</p> 
            <p style={paragraph}>2016-06-27 - Added a link to the non-keeper <a href="http://www.draftpicktradecalculator.com">draftpicktradecalculator.com</a>.</p> 
            <p style={paragraph}>2016-06-16 - Bumped picks values up to 90th percentile.</p>
            <p style={paragraph}>2016-06-15 - Fixed bug that wouldn't let user select two players
              with the same value.</p>
            <p style={paragraph}>2016-06-14 - Updated with preliminary 2016 PPR data. Added How
              It Works and Contact pages.</p>
            <p style={paragraph}>2016-06-13 - Added Changelog.</p>
          </div>
        </div>
      </div>
    )
  }
}

export default ChangeLog




// WEBPACK FOOTER //
// ./src/components/ChangeLog.js